import { CircularProgress, Stack, Typography } from '@mui/material';

export interface LoadingSpinnerProps {
  label?: string;
  size?: number;
}

/**
 * A spinner is acceptable only for short, unavoidable waits (a mutation in flight inside a
 * dialog) — content-heavy screens use a shape-matched skeleton instead (`components/common/Skeletons`,
 * docs/development/FrontendGuidelines.md §7.10).
 */
export function LoadingSpinner({ label, size = 32 }: LoadingSpinnerProps) {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={1.5} sx={{ py: 4 }} role="status">
      <CircularProgress size={size} aria-label={label ?? 'Loading'} />
      {label ? (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      ) : null}
    </Stack>
  );
}
